import React from 'react';
import {
    View,
    Text,
    StyleSheet,
    ScrollView,
    TouchableOpacity,
    Image,
    Linking,
    Platform,
} from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { COLORS } from '../config';

// Data lokasi cabang
const BRANCHES = [
    {
        id: 1,
        name: 'Rental PS Ming',
        address: 'Jl. Citra Raya Boulevard No.316 Blok S05, Ciakar, Kec. Panongan, Kabupaten Tangerang',
        phone: '081234567890',
        hours: 'Buka 24 Jam',
        image: require('../../assets/branch_ming.png'),
        mapsUrl: 'https://maps.app.goo.gl/3A4KftUdcM8HHw6v8?g_st=ipc',
        features: ['PS3', 'PS4', 'WiFi Gratis', 'Parkir'],
    },
    {
        id: 2,
        name: 'Rental PS Chandra x Ming',
        address: 'Jl. Raya H. Mirza Cinde Lakoni, Ciakar, Kec. Panongan, Kabupaten Tangerang',
        phone: '081234567891',
        hours: 'Buka 24 Jam',
        image: require('../../assets/branch_chandra.png'),
        mapsUrl: 'https://maps.app.goo.gl/3LSgkuFoG1BwvNRB6?g_st=ic',
        features: ['PS3', 'PS4', 'WiFi Gratis', 'Parkir'],
    },
];

export default function LokasiScreen({ navigation }) {
    const insets = useSafeAreaInsets();

    const openMaps = (url) => {
        Linking.openURL(url);
    };

    const callPhone = (phone) => {
        Linking.openURL(`tel:${phone}`);
    };

    return (
        <View style={styles.container}>
            {/* Header */}
            <View style={[styles.header, { paddingTop: insets.top + 12 }]}>
                <Text style={styles.headerTitle}>Lokasi Cabang</Text>
            </View>

            <ScrollView showsVerticalScrollIndicator={false} contentContainerStyle={styles.content}>
                <Text style={styles.subtitle}>Temukan cabang terdekat dan kunjungi kami!</Text>

                {BRANCHES.map((branch) => (
                    <View key={branch.id} style={styles.branchCard}>
                        {/* Branch Image */}
                        <Image
                            source={branch.image}
                            style={styles.branchImage}
                            resizeMode="cover"
                        />

                        {/* Branch Info */}
                        <View style={styles.branchInfo}>
                            <Text style={styles.branchName}>{branch.name}</Text>
                            <Text style={styles.branchAddress}>📍 {branch.address}</Text>
                            <Text style={styles.branchHours}>⏰ {branch.hours}</Text>

                            {/* Features */}
                            <View style={styles.featuresRow}>
                                {branch.features.map((feature, idx) => (
                                    <View key={idx} style={styles.featureTag}>
                                        <Text style={styles.featureText}>{feature}</Text>
                                    </View>
                                ))}
                            </View>

                            {/* Action Buttons */}
                            <View style={styles.actionRow}>
                                <TouchableOpacity
                                    style={styles.mapsBtn}
                                    onPress={() => openMaps(branch.mapsUrl)}
                                >
                                    <Text style={styles.mapsBtnText}>🗺️ Buka Maps</Text>
                                </TouchableOpacity>

                                <TouchableOpacity
                                    style={styles.callBtn}
                                    onPress={() => callPhone(branch.phone)}
                                >
                                    <Text style={styles.callBtnText}>📞 Telepon</Text>
                                </TouchableOpacity>
                            </View>
                        </View>
                    </View>
                ))}

                <View style={{ height: 100 }} />
            </ScrollView>
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: COLORS.bgDark,
    },
    header: {
        alignItems: 'center',
        justifyContent: 'center',
        paddingHorizontal: 16,
        paddingVertical: 16,
        backgroundColor: COLORS.bgDarker,
        borderBottomWidth: 1,
        borderBottomColor: COLORS.border,
    },
    backBtn: {
        width: 40,
        height: 40,
        justifyContent: 'center',
        alignItems: 'center',
    },
    backIcon: {
        fontSize: 24,
        color: COLORS.textPrimary,
    },
    headerTitle: {
        fontSize: 18,
        fontWeight: '700',
        color: COLORS.textPrimary,
    },
    content: {
        padding: 16,
    },
    subtitle: {
        fontSize: 14,
        color: COLORS.textSecondary,
        textAlign: 'center',
        marginBottom: 20,
    },
    branchCard: {
        backgroundColor: COLORS.bgCard,
        borderRadius: 20,
        overflow: 'hidden',
        marginBottom: 20,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 4 },
        shadowOpacity: 0.1,
        shadowRadius: 12,
        elevation: 5,
    },
    branchImage: {
        width: '100%',
        height: 160,
    },
    branchInfo: {
        padding: 16,
    },
    branchName: {
        fontSize: 20,
        fontWeight: '800',
        color: COLORS.textPrimary,
        marginBottom: 8,
    },
    branchAddress: {
        fontSize: 14,
        color: COLORS.textSecondary,
        marginBottom: 4,
    },
    branchHours: {
        fontSize: 14,
        color: '#22c55e',
        fontWeight: '600',
        marginBottom: 12,
    },
    featuresRow: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: 8,
        marginBottom: 16,
    },
    featureTag: {
        backgroundColor: COLORS.primary + '20',
        paddingHorizontal: 10,
        paddingVertical: 4,
        borderRadius: 12,
    },
    featureText: {
        fontSize: 11,
        color: COLORS.primary,
        fontWeight: '600',
    },
    actionRow: {
        flexDirection: 'row',
        gap: 12,
    },
    mapsBtn: {
        flex: 1,
        backgroundColor: COLORS.primary,
        paddingVertical: 12,
        borderRadius: 12,
        alignItems: 'center',
    },
    mapsBtnText: {
        color: 'white',
        fontWeight: '700',
        fontSize: 14,
    },
    callBtn: {
        flex: 1,
        backgroundColor: '#22c55e',
        paddingVertical: 12,
        borderRadius: 12,
        alignItems: 'center',
    },
    callBtnText: {
        color: 'white',
        fontWeight: '700',
        fontSize: 14,
    },
});
